<template>
  <div>
    <van-tabbar v-model="active" v-show="!isKeyboardOpen"> <!-- 键盘弹出时隐藏 -->
      <van-tabbar-item to="/connection">
        <van-icon name="wap-home-o" class="tabbarIcon" />
        联系我们
      </van-tabbar-item>
      <van-tabbar-item to="/message" style="border-left: 1px solid #ccc;border-right: 1px solid #ccc;">
        <van-icon name="chat-o" class="tabbarIcon" />
        信息通知
      </van-tabbar-item>
      <van-tabbar-item to="/product">
        <van-icon name="apps-o" class="tabbarIcon" />
        产品中心
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>


<script>
export default {
  data() {
    return {
      active: 0,
      isKeyboardOpen: false, // 用于跟踪键盘是否打开
    };
  },
  mounted() {
    // 监听窗口大小的变化，判断键盘是否打开
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // 判断窗口高度变化是否为键盘弹出/收起
      if (window.innerHeight < 500) { // 可以根据具体设备和需求调整高度
        this.isKeyboardOpen = true;
      } else {
        this.isKeyboardOpen = false;
      }
    }
  }
}

</script>
 
<style >
.van-tabbar-item__text {
  font-size: 0.14rem;
  vertical-align: middle;
}

.tabbarIcon {
  vertical-align: bottom;
}
</style>